import { langMap, LangEnum } from './lang';

const LANG_CODE_TO_ENUM: Record<string, LangEnum> = {
  ru: LangEnum.RU,
  en: LangEnum.EN,
  kz: LangEnum.KZ,
  kk: LangEnum.KZ,
  ch: LangEnum.CH,
};

const SPECIAL_LANGUAGE_LABELS: Record<string, string> = {
  es: 'Español',
  ky: 'Кыргызча',
  emoji: 'Emoji',
  junk: 'Junk',
};

/** Единая расшифровка языковых кодов для дашбордов и внешних отзывов. */
export function getLanguageLabel(code: string): string {
  const normalizedCode = code.trim().toLowerCase();
  const langEnum = LANG_CODE_TO_ENUM[normalizedCode];
  if (langEnum) return langMap[langEnum];
  if (SPECIAL_LANGUAGE_LABELS[normalizedCode]) return SPECIAL_LANGUAGE_LABELS[normalizedCode];
  return normalizedCode ? normalizedCode.toUpperCase() : '';
}

